import { isWindowUserAgentCinchApp } from '@cinch-nx/search-shared'
import {
  TrustpilotWidget,
  TrustpilotWidgetTemplates,
  Wrapper,
} from '@cinch-nx/shared-ui'
import styles from './customer-reviews.module.css'
import { Head, renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { FullWidthCTA } from '@cinch-labs/design-system'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { useRouter } from 'next/router'
import { Intro } from './components/intro'
import { CustomerReviewsProps } from './get-static-props'
import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { CustomerReviewsSection } from './components/customer-reviews-section/customer-reviews-section'

export function CustomerReviews({
  story,
  generatedAt,
  preview,
}: CustomerReviewsProps) {
  const { content } = useStoryblokState({ story, enableBridge: preview })
  const {
    intro,
    SEO,
    HowCinchWorksComponent,
    FaffFreeMotoringComponent,
    PreFooterCta,
  } = content

  const IntroSection = intro[0]
  const SeoSection = SEO[0]
  const HowCinchWorksSection = HowCinchWorksComponent[0]
  const FaffFreeMotoringSection = FaffFreeMotoringComponent[0]
  const PreFooterSection = PreFooterCta[0]
  const contentIntroText = renderWithResolver(IntroSection.body)

  const router = useRouter()
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    trackEvent({
      eventName: `Customer Reviews -  click search all cars button`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'customer reviews page',
          label: 'button in page',
          action: 'view all cars',
        },
      },
    })
    router.push(PreFooterSection.CtaButton[0].url)
  }

  return (
    <>
      <Head
        {...SeoSection}
        generatedAt={generatedAt}
        fallbackTitle="cinch reviews and customer testimonials"
        fallbackDescription="Official cinch reviews from happy customers enjoying faff-free motoring. Don't just take our word for it - read cinch reviews now."
      />
      <article className={styles.root}>
        <Wrapper className={{ container: styles.teaserContainer }} isSlim>
          <Intro introText={contentIntroText} title={IntroSection.title} />
        </Wrapper>
        <Wrapper className={{ container: styles.teaserContainer }} isSlim>
          <TrustpilotWidget
            widget={TrustpilotWidgetTemplates.grid}
            height={'500px'}
          />
        </Wrapper>
        {!isWindowUserAgentCinchApp && (
          <>
            <div className={styles.customerReviewsSectionContainer}>
              <CustomerReviewsSection
                howCinchWorks={HowCinchWorksSection}
                faffFreeMotoring={FaffFreeMotoringSection}
              />
            </div>
            <FullWidthCTA
              iconName="search"
              iconGradient="galaxy"
              iconSize={41}
              title={PreFooterSection.title}
              subtitle={PreFooterSection.subtitle}
              buttonLabel={PreFooterSection.CtaButton[0].label}
              onButtonClick={handleClick}
            />
          </>
        )}
      </article>
    </>
  )
}

export default CustomerReviews
